var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpeed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 23,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  clipPath: "url(#speed_svg__a)",
  opacity: 0.8
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.357 9.764a1 1 0 0 0-1.414 0l-2.853 2.853a1.902 1.902 0 0 0-2.344 1.854c0 1.05.854 1.906 1.904 1.906a1.908 1.908 0 0 0 1.855-2.346l2.852-2.852a1 1 0 0 0 0-1.415"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.78 5.943c-4.289-4.29-11.27-4.29-15.563 0-3.704 3.706-4.278 9.552-1.365 13.9a1 1 0 0 0 1.662-1.113 8.94 8.94 0 0 1-1.457-3.979h.94a1 1 0 0 0 0-2h-.943a9 9 0 0 1 1.9-4.632l.68.68a.997.997 0 0 0 1.415 0 1 1 0 0 0 0-1.414L5.365 6.7a8.97 8.97 0 0 1 4.677-1.925v.945a1 1 0 0 0 2 0v-.936a8.96 8.96 0 0 1 4.593 1.916l-.684.684a1 1 0 0 0 1.415 1.414l.68-.68a9 9 0 0 1 1.9 4.632h-.943a1 1 0 1 0 0 2h.94a8.94 8.94 0 0 1-1.458 3.979 1 1 0 1 0 1.662 1.114c2.915-4.349 2.34-10.195-1.366-13.902"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.508 18.838H6.49a1 1 0 0 0 0 2h9.017a1 1 0 1 0 0-2"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "speed_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .782h22v22H0z"
})))));
export { SvgSpeed as ReactComponent };
export default __webpack_public_path__ + "static/media/speed.14f84303.svg";